import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { getDesignToken, spacing } from 'styles/constants';

import { MethodType, TextContainer } from './styled';

interface IPayPalMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const PayPalMethod: FC<IPayPalMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: spacing.$2 }
    : null;

  return (
    <TextContainer>
      <MethodType
        color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}
        {...textProps}
      >
        {t('paypal')}
      </MethodType>
    </TextContainer>
  );
};

export default PayPalMethod;
